{
	"title": "Πρέπει να συνδεθείτε",
	"description": "Για να δείτε αυτήν τη σελίδα, είναι απαραίτητο να συνδεθείτε. Παρακαλούμε συνδεθείτε. Στη συνέχεια, θα ανακατευθυνθείτε στη σελίδα που ζητήσατε.",
	"primaryButtonTitle": "Άνοιγμα σύνδεσης"
}
